'use strict';

/**
 * Initialize Testimonial
 */
function initTestimonial() {
    var $carousel = $('.testimonial-scroller .experience-region');
    let carouselLength = $carousel.length;
    if (carouselLength && carouselLength > 0) {
        $carousel.each(function () {
            let configEle = $(this).closest('.testimonial-scroller');
            if (configEle === null || configEle === undefined) {
                return true;
            }

            let config = {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: configEle.data('showdots-md'),
                arrows: configEle.data('showarrows-md'),
                fade: true,
                cssEase: 'ease-in-out',
                speed: 300,
                prevArrow: configEle.siblings('.testimonial-btn-container').find('.testimonial-btn-prev'),
                nextArrow: configEle.siblings('.testimonial-btn-container').find('.testimonial-btn-next'),
                infinite: configEle.data('mdcarouselinfinte'),
                responsive: [
                    {
                        breakpoint: 999,
                        settings: {
                            dots: configEle.data('showdots-sm'),
                            arrows: configEle.data('showarrows-sm'),
                            infinite: configEle.data('smcarouselinfinte')
                        }
                    },
                    {
                        breakpoint: 599,
                        settings: {
                            dots: configEle.data('showdots-xs'),
                            arrows: configEle.data('showarrows-xs'),
                            infinite: configEle.data('xscarouselinfinte')
                        }
                    }
                ]
            };

            $(this).slick(config);
            return true;
        });
    }
}

$(document).ready(function () {
    initTestimonial();
});
